export type BookStatus = 'in queue' | 'reading' | 'occasional reference' | 'done' | 'abandoned' | 'probably not' | "won't read";

export const STANDARD_ITEM_TYPES = ['book', 'poem', 'play', 'essay', 'article', 'short story'] as const;

export interface Book {
  uuid: string;
  title: string;
  author?: string;
  item_type?: string;
  status: BookStatus;
  queue_position: number;
  is_section?: boolean;
  parent_uuid?: string;
  section_description?: string;
}

export interface BookNote {
  uuid: string;
  book_uuid: string;
  content: string;
  created_at?: string;
  updated_at?: string;
}

export type HistoryEventType = 'book_added' | 'status_changed' | 'note_created' | 'note_updated';

export interface BookHistoryEvent {
  uuid: string;
  book_uuid: string;
  event_type: HistoryEventType;
  details: {
    title?: string;
    author?: string;
    item_type?: string;
    initial_status?: BookStatus;
    old_status?: BookStatus;
    new_status?: BookStatus;
  };
  created_at: string;
}
